import Vue from 'vue';
import {
    GET_LISTING_STATUS,
    SET_LISTING_STATUS,
    GET_LISTING,
    SET_LISTING,
    GET_MARKET_REPORT,
    SET_MARKET_REPORT,
    SET_TOTAL_PAGE,
    ADD_SOLD_PICTURE
} from './constants';
import { checkSoldHousePreview } from '@/common/utils';
import { getListingStatus, getSnapshotListing, getMarketReport } from '../api';
export default {
    // 从后端接口获取 listing status 并赋值
    async [GET_LISTING_STATUS]({ commit }, payload = {}) {
        let ret = await getListingStatus(payload.data);
        commit({
            type: SET_LISTING_STATUS,
            data: ret.data
        });
    },
    // 从后端接口获取 listing 并赋值
    async [GET_LISTING]({ commit, dispatch }, payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        let ret = await getSnapshotListing(params);
        commit({
            type: SET_LISTING,
            data: ret.listings
        });
        // 设置分页
        commit({
            type: SET_TOTAL_PAGE,
            data: ret.totalPage
        });
        // 补图
        dispatch(ADD_SOLD_PICTURE);
    },
    // 从 后端接口获取 market report 并赋值
    async [GET_MARKET_REPORT]({ commit }, payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        params.listingType = 'sold-listing'; // 写死
        let ret = await getMarketReport(params);
        commit({
            type: SET_MARKET_REPORT,
            data: ret.data && ret.data.marketReport
        });
    },
    // add picture
    async [ADD_SOLD_PICTURE]({ state }) {
        const { listing } = state;
        checkSoldHousePreview({ listings: listing }, Vue.set);
    }
};
